"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoInvoiceCloseReason = void 0;
var CryptoInvoiceCloseReason;
(function (CryptoInvoiceCloseReason) {
    CryptoInvoiceCloseReason["EXPIRED"] = "EXPIRED";
    CryptoInvoiceCloseReason["MANUAL"] = "MANUAL";
    CryptoInvoiceCloseReason["PAID"] = "PAID";
})(CryptoInvoiceCloseReason = exports.CryptoInvoiceCloseReason || (exports.CryptoInvoiceCloseReason = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3J5cHRvSW52b2ljZUNsb3NlUmVhc29uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0NyeXB0b0ludm9pY2VDbG9zZVJlYXNvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLHdCQUlYO0FBSkQsV0FBWSx3QkFBd0I7SUFDbEMsK0NBQW1CLENBQUE7SUFDbkIsNkNBQWlCLENBQUE7SUFDakIseUNBQWEsQ0FBQTtBQUNmLENBQUMsRUFKVyx3QkFBd0IsR0FBeEIsZ0NBQXdCLEtBQXhCLGdDQUF3QixRQUluQyJ9